/* Intelligence Page — LLM-curated news feed and AI briefs
   Uses Phase 4.1 components with tab switching */

import { renderMorningBrief } from '../components/MorningBrief';
import { renderPriorityFeed } from '../components/PriorityFeed';
import { renderSectorIntelligence } from '../components/SectorIntelligence';
import { renderEventTimeline } from '../components/EventTimeline';
import { renderEarningsTracker } from '../components/EarningsTracker';
import { renderNewsSearch } from '../components/NewsSearch';
import { renderPhase2IntelligenceEngine } from '../components/charts/Phase2IntelligenceEngine';
import { isFeatureEnabled } from '../services/runtime-config';

const TABS = [
  { id: 'brief', label: '🌅 Brief', render: renderMorningBrief },
  { id: 'feed', label: '🔥 Feed', render: renderPriorityFeed },
  { id: 'sectors', label: '📊 Sectors', render: renderSectorIntelligence },
  { id: 'earnings', label: '💰 Earnings', render: renderEarningsTracker },
  { id: 'events', label: '📅 Events', render: renderEventTimeline },
  { id: 'search', label: '🔍 Search', render: renderNewsSearch },
];

let detachCommandHandlers: (() => void) | null = null;

export function renderIntelligence(): string {
  if (isFeatureEnabled('charts_v2_engine')) {
    return '<div id="intel-v2-root"></div>';
  }

  const tabButtons = TABS.map((t, i) =>
    `<button class="glass-btn ${i === 0 ? 'glass-btn--primary' : ''}" data-intel-tab="${t.id}" style="justify-content: flex-start;">${t.label}</button>`
  ).join('');

  return `
    <div class="grid-intelligence">
      <div id="intel-tabs" style="display: flex; flex-direction: column; gap: var(--space-2);">
        ${tabButtons}
      </div>
      <div id="intel-content"></div>
    </div>
  `;
}

export function initIntelligence(): void {
  if (isFeatureEnabled('charts_v2_engine')) {
    const root = document.getElementById('intel-v2-root');
    if (root) renderPhase2IntelligenceEngine(root);
    return;
  }

  const contentEl = document.getElementById('intel-content');
  const tabsEl = document.getElementById('intel-tabs');
  if (!contentEl || !tabsEl) return;

  const switchTab = (tabId: string): void => {
    const tab = TABS.find(t => t.id === tabId);
    if (!tab) return;

    tabsEl.querySelectorAll('.glass-btn').forEach(b => b.classList.remove('glass-btn--primary'));
    const activeBtn = tabsEl.querySelector(`[data-intel-tab="${tabId}"]`);
    activeBtn?.classList.add('glass-btn--primary');
    tab.render(contentEl);
  };

  // Render first tab
  switchTab(TABS[0].id);

  // Tab switching
  tabsEl.querySelectorAll('[data-intel-tab]').forEach(btn => {
    btn.addEventListener('click', () => {
      const tabId = (btn as HTMLElement).dataset.intelTab;
      if (!tabId) return;
      switchTab(tabId);
    });
  });

  if (detachCommandHandlers) {
    detachCommandHandlers();
  }

  const onNews = () => {
    switchTab('feed');
  };

  document.addEventListener('imm:command:news', onNews);

  detachCommandHandlers = () => {
    document.removeEventListener('imm:command:news', onNews);
  };
}
